
import { combineReducers } from 'redux'
import Register from "./Register"


export default combineReducers({
    Register


})